export const TRANSFORM_ERROR_SEEN_KEY = "transform-native-variable-error";
